
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface JoinWaitlistButtonProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const JoinWaitlistButton = ({ className, style, children = "Next" }: JoinWaitlistButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button 
      variant="outline"
      className={`bg-white text-black hover:bg-white/90 ${className}`}
      style={style}
      onClick={() => navigate("/download")}
    >
      {children}
      <ArrowRight className="ml-2 h-5 w-5" />
    </Button>
  );
};

export default JoinWaitlistButton;
